<template>
    <div v-if="!registrationStore.registeringCompany.phoneVerified">
        <p class="cr:mb-5 cr:font-medium">
          Please enter the code sent to <strong>{{ registrationStore.registeringCompany.phone }}</strong>.
        </p>
        <div class="cr:grid cr:grid-cols-1 cr:sm:grid-cols-2 cr:gap-5 cr:items-center" v-if="codeSent">
            <CustomInput
                v-model="verificationCode"
                :placeholder="'Enter Verification Code'"
            />
            <CustomButton
                :color="'origin'"
                @click="verify"
                :disable-button="!verificationCode || apiRequest"
            >
                Verify
            </CustomButton>
        </div>
        <div v-else>
            <CustomButton
                :color="'origin'"
                :small="true"
                @click="sendCode"
                :disable-button="apiRequest"
            >
                Send Code
            </CustomButton>
        </div>
    </div>
    <div class="cr:text-green-400 cr:inline-flex cr:font-semibold cr:items-center cr:justify-center" v-else>
        <p class="cr:mr-1 cr:text-xl">Phone Verified</p>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cr:h-7 cr:w-7">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
    </div>
</template>

<script setup lang="ts">

import CustomButton from "@/components/elements/CustomButton.vue";
import CustomInput from "@/components/elements/CustomInput.vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import {onBeforeMount, ref} from "vue";
import {useErrorStore} from "@/stores/error.ts";

const registrationStore = useRegistrationStore();
const errorStore = useErrorStore();
const codeSent = ref(true);
const verificationCode = ref('');
const apiRequest = ref(false);

const props = defineProps({
    sendCode: {
        type: Boolean,
        default: false
    }
});

onBeforeMount(() => {
    codeSent.value = !props.sendCode;
});

const emit = defineEmits(['verified']);

const sendCode = () => {
    apiRequest.value = true;
    registrationStore.apiService.sendPhoneVerificationCode(registrationStore.registeringCompany.reference ?? '')
        .then(() => codeSent.value = true)
        .catch(e => {
            errorStore.report('Something went wrong. Please try again.')
            console.error(e);
        })
        .finally(() => apiRequest.value = false);
};
const verify = () => {
    apiRequest.value = true;
    registrationStore.apiService.verifyPhone(registrationStore.registeringCompany.reference ?? '', verificationCode.value)
        .then((resp) => {
            if (resp.data.data.status) {
                registrationStore.registeringCompany.phoneVerified = true;
                emit('verified');
            } else {
                errorStore.report('The code entered is incorrect.')
            }
        })
        .catch(e => {
            errorStore.report('Something went wrong. Please try again.')
            console.error(e);
        })
        .finally(() => apiRequest.value = false);
};

</script>